const captureTextFields = new Set(['item', 'work_order', 'pallet_no', 'roll_no', 'serial_or_part', 'code', 'notes']);

export const uppercaseConversionCapture = (record) => Object.fromEntries(
  Object.entries(record).map(([field, value]) => [
    field,
    captureTextFields.has(field) && typeof value === 'string' ? value.toUpperCase() : value,
  ])
);
